import React, { useEffect, useState } from 'react'
import { Button, TableCell } from '@material-ui/core'

import EditIcon from '@material-ui/icons/Edit'
import { connect } from 'react-redux'
import { ButtonGrid } from '../../components'
import {
  getConcreteMonitorDevice,
  getCurrentUser,
} from '../../state/DeviceById/selectors'
import { getLastLog } from '../../state/Firebase/operations'
import { editDeviceStart } from '../../state/SystemCache/actions'
import { Device, LogRaw, State, User } from '../../types'
import { toYmdHmsStr } from '../../utils'

type Props = {
  device: Device | undefined
  user?: User
  deviceId: string
  handleEditDevice: () => void
}

function DeviceListItem(props: Props) {
  const { device, user } = props
  const [lastLog, setLastlog] = useState<LogRaw | null>(null)

  useEffect(() => {
    if (!device || device.category !== 'yuatsu') return
    getLastLog(device).then((log) => setLastlog(log))
    // eslint-disable-next-line
  }, [device?.id])

  if (!device) {
    return (
      <tr>
        <TableCell>loading {props.deviceId}</TableCell>
      </tr>
    )
  }
  const toClientLabel = (user?: User) => {
    if (!user) return '-'
    return `${user.company} ${user.label || user.email}`
  }

  return (
    <tr>
      <TableCell>{device.id}</TableCell>
      <TableCell>{device.info.label}</TableCell>
      <TableCell>{device.info.memo}</TableCell>
      <TableCell>{toClientLabel(user)}</TableCell>
      {device.category === 'yuatsu' && (
        <TableCell>
          {lastLog ? (
            <>
              {lastLog.fields['volt'] || '-'}(
              {toYmdHmsStr(new Date(lastLog.timestamp))})
            </>
          ) : null}
        </TableCell>
      )}

      <TableCell>
        <ButtonGrid>
          <Button onClick={props.handleEditDevice}>
            <EditIcon />
            変更
          </Button>
        </ButtonGrid>
      </TableCell>
    </tr>
  )
}
// function DeviceListItemMemo(props: Props) {
//   const child = React.useMemo(
//     () => <DeviceListItem {...props} />,
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [props.device],
//   )
//   return <>{child}</>
// }

type OProps = {
  deviceId: string
}
type DProps = {
  editDeviceStart: (id: string) => void
}
type SProps = {
  device: Device | undefined
  user: User
}

const conn = connect<SProps, DProps, OProps, Props, State>(
  (state, op) => ({
    device: getConcreteMonitorDevice(state, op.deviceId),
    user: getCurrentUser(state, op.deviceId),
  }),
  { editDeviceStart },
  (sp, dp, op) => ({
    ...sp,
    ...op,
    handleEditDevice: () => dp.editDeviceStart(op.deviceId),
  }),
)
const DeviceListItemContainer = conn(DeviceListItem)

export default DeviceListItemContainer
